// An installed wall opens at /wall/ with no link in the address: the manifest cannot hold the secret (it would be the same for every event). So the device remembers the
// wall link it last showed, in its own storage, and takes it up again when it is opened without one (A.2, 24 Oct 2026). The link is the bearer of the wall already (it is in
// the address and in the browser's history); keeping it on the same device adds nothing anybody could not already read there, and it is forgotten the moment the server says
// it no longer works. Nothing leaves the device.

export const WALL_KEY = 'kwento.wall.link'
/** The shape of a wall link: 22 letters and digits today; a bounded, plain alphabet so that whatever is in storage is never trusted as more than that. */
const SHAPE = /^[A-Za-z0-9_-]{16,64}$/

type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

export function rememberWall(store: Store | null, token: string): void {
  if (!store || !SHAPE.test(token)) return
  try {
    store.setItem(WALL_KEY, token)
  } catch {
    // Private mode, a full disk: the wall works the same, it just will not reopen by itself.
  }
}

export function recallWall(store: Store | null): string | null {
  if (!store) return null
  try {
    const v = store.getItem(WALL_KEY)
    return v && SHAPE.test(v) ? v : null
  } catch {
    return null
  }
}

export function forgetWall(store: Store | null): void {
  try {
    store?.removeItem(WALL_KEY)
  } catch {
    // nothing to do
  }
}

/** localStorage when the browser allows it (it throws in some private modes and blocked-storage settings), else null. */
export function deviceStore(): Store | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}
